<template>
  <div class="container product-card-container">
      <div class="product-card-image-container">
        <AdvHtmlPicture
          :srcset-image="product.main_image_url"
          :alt="product.name"
          srcset-profile="from_w120"
        />
      </div>
      <div class="product-card-info-container">
        <div class="col-12">
          <h3>{{ product.name }}</h3>
        </div>
        <div class="col-12">
          <p>{{ t('total')}}: <strong>{{ product.final_price }}</strong> {{ getSelectedCurrency.code }}</p>
        </div>
      </div>
  </div>
</template>

<script>
import AdvHtmlPicture from '../../vue/components/AdvHtmlPicture.vue'
import { mapGetters } from 'vuex'

export default {
  name: 'leasingCheckoutProductCard',
  components: {
    AdvHtmlPicture
  },
  props: {
    product: {
      type: Object,
      required: true
    }
  },
  computed: {
    ...mapGetters(['getSelectedCurrency'])
  }
}
</script>

<style lang="scss" scoped>
.product-card-container {
  display: grid;
  grid-template-columns: auto 1fr;
  align-items: center;
  margin-top: 6rem;
  background: #f3f3f3;
  padding: 0.5rem;
  border-radius: 5px;
}
</style>
